// Client: one tenant per tab, so a plain global is safe. Server: per-request
// state lives in an AsyncLocalStorage (+onRenderHtml.jsx), wired in via setTenantGetter.
let serverGetter = null;

export function setTenantGetter(fn) {
    serverGetter = fn;
}

export function currentTenant() {
    if (typeof window !== 'undefined') {
        return {
            messages: window.__SITE_CONFIG__,
            faq: window.__SITE_FAQ__,
            about: window.__SITE_ABOUT__,
        };
    }
    return serverGetter ? serverGetter() : undefined;
}

export function getSiteFaq() {
    return currentTenant()?.faq ?? [];
}

export function getSiteAbout() {
    return currentTenant()?.about ?? [];
}
